/*
 * @Author: 李文敬
 * @version: 1.0.0
 * @Company: 和顺旭基(深圳)中医药科技有限公司
 * @Description:
 * @Date: 2021-07-27 18:13:42
 * @LastEditors: 李文敬
 * @LastEditTime: 2025-06-11 09:36:25
 */
/**
 * @desc   公共配置
 * @author yyy
 */
let baseURL, LocPrefix
switch (process.env.NODE_ENV) {
  case `development`:
    baseURL = 'http://120.78.145.204:6504/index/'
    LocPrefix = 'wellsoon_'
    break
  case `sit`:
    baseURL = 'http://120.78.145.204:6504/index/'
    LocPrefix = 'wellsoon_'
    break
  case `uat`:
    baseURL = 'http://120.78.145.204:6504/index/'
    LocPrefix = 'wellsoon_'
    break
  case `production`:
    baseURL = 'https://www.wellsoon.cn/index/'
    LocPrefix = 'wellsoon_'
    break
  default:
    throw new Error('unknown env')
}
export {
  baseURL,
  LocPrefix
}



// WEBPACK FOOTER //
// ./src/config/index.js